export const NAVS = ["Profile", "Help"];
